import { CollideEvent, CollideId } from '../../defs/collide';
import { type SpiderBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { hasBlockBelow } from '../../util/mapTools';
import { InvalidEffect } from '../effects/InvalidEffect';
import { SpiderFallEffect } from '../effects/SpiderFallEffect';
import { CollideHandler, ICollision } from './ICollision';

/*
  spider block collision resolver
*/
export class SpiderCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: SpiderBlockEntity;
  private readonly _resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    fall: this.resolveFall,
  };

  constructor(scene: GameScene, entity: SpiderBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this._resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap() {
    // invalid effect
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveFall() {
    // mark as moved down in this phase cycle
    this.entity.c.blockSpider.movedDown = true;

    // if there is no block below, destroy this spider
    if (!this._findBlockBelow()) {
      // do not wait for the kill effect.
      new SpiderFallEffect(this.scene, {
        entity: this.entity,
      }).execute();

      return true;
    }
    return false;
  }

  private _findBlockBelow(): boolean {
    return hasBlockBelow(this.scene.sessionEntity.c.map, this.entity);
  }
}
